import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useStore } from '../../contexts/StoreContext';
import { getDefaultRedirectPath } from '../../utils/navigation.utils';
import PageLoader from '../PageLoader/PageLoader';

/**
 * DefaultRedirect Component
 * Handles redirection to the user's preferred default page after login.
 * If the user has no store selected (e.g. new user or no access yet),
 * redirects to the stores page to create or join a store.
 */
const DefaultRedirect: React.FC = () => {
  const { user, isLoading } = useAuth();
  const { currentStore } = useStore();

  // Show loader while checking authentication
  if (isLoading) {
    return <PageLoader />;
  }

  // If user is not authenticated, this shouldn't be reached (PrivateRoute handles it)
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // No store selected: redirect to stores page (create store or accept invitation)
  if (!currentStore) {
    return <Navigate to="/stores" replace />;
  }

  // Get redirect path based on user preferences
  const redirectPath = getDefaultRedirectPath(user.preferences);

  return <Navigate to={redirectPath} replace />;
};

export default DefaultRedirect;

